import { WorldList, WorldInfo } from './../data/WorldInfo';
import { userRecord } from './../data/UserRecord';
import { Popup } from './Popup';
import { app } from './../app.world';
import { FW } from './../framework/Framework';
import { BaseScreen } from './BaseScreen';

export class GameCover extends BaseScreen {

    private _sprite: GAF.GAFMovieClip;

    constructor() {
        super();

        this._sprite = FW.gafManager.createMovieClip('worlds', 'lib_worlds_cover');
        FW.root.addChild(this._sprite);

        for(let world of WorldList) {
            this.setupWorldButton(world);
        }

        this.setupButton(this._sprite['buttonBack'], () => {
            app.showCover();
        }, 'Back');
    }

    public get sprite(): GAF.GAFMovieClip {
        return this._sprite;
    }

    private setupWorldButton(world:WorldInfo): void {
        var clip: GAF.GAFMovieClip = this._sprite[world.code];

        if (userRecord.isWorldLocked(world.code)) {
            clip.gotoAndStop('locked');
        } else {
            clip.gotoAndStop(world.code);
            let progress:number = Math.round(userRecord.getWorldProgress(world.code) * 100);
            clip['progress']['field'].y += 12;
            clip['progress']['field'].set_text('' + progress + '%');
            this.setupButton(clip['buttonPlay'], () => {
                new Popup().forWorldSelect(world)
                .then(wcode => app.enterWorld(wcode));
            }, 'Play');
        }

    }
}


// WEBPACK FOOTER //
// ./src/worlds/GameCover.ts